import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserRepositoriesFactory from '../Repositories/factory.js'

/**
 * Use case for parsing blocked user cookies from request strings
 * This provides a reusable and testable way to handle cookie parsing
 * instead of doing it directly in components or getInitialProps functions
 */
export class ParseBlockedUserCookiesUseCase extends UseCase {
  #config
  #cookieUserCochesRepository

  constructor({config, cookieUserCochesRepository}) {
    super()
    this.#config = config
    this.#cookieUserCochesRepository = cookieUserCochesRepository
  }

  static create({config}) {
    return new ParseBlockedUserCookiesUseCase({
      config,
      cookieUserCochesRepository: UserRepositoriesFactory.cookieUserRepository({config})
    })
  }

  @tracer({metric: 'ParseBlockedUserCookiesUseCase#execute'})
  execute() {
    try {
      return this.#cookieUserCochesRepository.getBlockedUsers()
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export const factory = ParseBlockedUserCookiesUseCase.create
